import { defineStore } from 'pinia'

export const useAppStore = defineStore(
  'app',
  {
    state: () => ({
      sidebar: {
        opened: true,
        hide: false
      },
    }),
    actions: {
      toggleSideBar() {
        this.sidebar.opened = !this.sidebar.opened
      },
      toggleSideBarHide(status) {
        this.sidebar.hide = status
      }
    }
  })
